var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtmlImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.601,
    height: 12,
    viewBox: "0 0 9.601 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14461"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.936 49.665v1.2h-.6v-1.2h-1.8a.6.6 0 0 1-.6-.6v-1.8h-6v3.6h-.6v-3.6a.6.6 0 0 1 .6-.6h6a.6.6 0 0 1 .426.174l2.4 2.4a.6.6 0 0 1 .174.426zm-.6 8.4h-8.4v-.6h-.6v.6a.6.6 0 0 0 .6.6h8.4a.6.6 0 0 0 .6-.6v-.6h-.6z",
    transform: "translate(-163.336 -46.666)",
    style: {
      fill: "#203662"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14459"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21008",
    d: "M8.4 8.4V6h-.6v3h1.8v-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21009",
    d: "M7.2 6h-.6l-.45 1.2L5.7 6h-.6v3h.6V6.9l.45 1.2.45-1.2V9h.6z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21010",
    d: "M2.7 6.6h.6V9h.6V6.6h.6V6H2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21011",
    d: "M1.5 6v1.2H.6V6H0v3h.6V7.8h.9V9h.6V6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlImage);
export default __webpack_public_path__ + "static/media/HtmlImage.6be931b667981c6c1360b4fc9bf9a987.svg";
export { ForwardRef as ReactComponent };